import { Backdrop, CircularProgress } from "@mui/material";
import api from "api/api";
import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import useModalStore from "zustand/zustandstore";

const SectionUpdate = ({ modal, setIsuploadmodal,fetchBasicData, dropdownData, cards, setSeverity, setOpen, setAlertMessage }) => {
  const [uploadedSignature, setUploadedSignature] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [extractedText, setExtractedText] = useState(""); // Store extracted text
const [submit,setSubmit]=useState(false)
const mydata=useModalStore()
const [templateName, setTemplateName] = useState("");
  const { getRootProps, getInputProps } = useDropzone({
    accept: { "application/pdf": [".pdf"], "image/png": [".png"], "image/jpeg": [".jpeg", ".jpg"] },
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length) {
        setUploadedSignature(acceptedFiles[0]);
        extractimg(acceptedFiles[0])
      }
    },
  });

  const extractimg = async (img) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", img);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      
      if (selectedSection) {
        config.params = { section_name: selectedSection };
      }
      
      const uploadedFile = await api.post(`/v1/user_templates/template_extraction`, formData, config);
      
      

      if (uploadedFile.status === 200) {
        setExtractedText(uploadedFile?.output||''); // Store extracted text
        setAlertMessage("Template Extraction Successfull");
        setSeverity("success");
        setOpen(true);

      } else {
        setAlertMessage("Something Went Wrong");
        setSeverity("error");
        setOpen(true);
      }
      console.log("File uploaded successfully:", uploadedFile);
    } catch (error) {
      console.error("Error uploading file:", error);
      setSeverity("error");
      setAlertMessage("Something Went Wrong");
      setOpen(true);
      setUploadedSignature(null);
    } finally {
      setLoading(false);
   
    }
  };

  const handleSave = async () => {
 
   
try {
    setSubmit(true)
          // const response = await api.get('/auth/me');
let obj={
      
  "template_name": templateName,
 "template_prompt":extractedText,
  }
  if(mydata.usertype==='PRO'){
    obj.section_name=selectedSection
  }

   const  savetemplate=await api.post('/v1/user_templates/save_template',obj)
       if(savetemplate.status===200){
         setSeverity('success')
         setOpen(true);
         setAlertMessage('Successfully saved the template');
       }else{
         setSeverity('error')
         setOpen(true);
         setAlertMessage('Something Went Wrong')
       }
} catch (error) {
   console.log(error) 
}finally{
setSubmit(false)
fetchBasicData()
setExtractedText('')
setUploadedSignature(null)
setSelectedTemplate('')
setTemplateName('')
setSelectedSection('')
window.location.reload();
setIsuploadmodal(false);
}
    
    
};
const formatSection = (section) => {
  return section
    .toLowerCase()
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/^./, (char) => char.toUpperCase()); // Capitalize first letter
};


  const isUploadEnabled = ((selectedTemplate && selectedSection)||mydata.usertype!=='PRO' )&& uploadedSignature&&extractedText&&templateName;
  if (!modal) return null;

  // Extract templates and sections dynamically

  const templates = Object.keys(cards.reduce((acc, obj) => ({ ...acc, ...obj }), {}));
  const sections = selectedTemplate ? Object.keys(cards.find(obj => obj[selectedTemplate])?.[selectedTemplate] || {}) : [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-[90%] sm:w-[35%] h-auto flex flex-col rounded-md shadow-lg p-6 space-y-4">
        <h2 className="text-xl font-semibold text-[#1c2a3a] text-left">Upload template</h2>
        <div className="flex flex-col">
          <label className="font-medium text-start text-sm mb-2 text-[#1c2a3a]">Template Name</label>
          <input
            type="text"
            className="border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-[#1c2a3a]"
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
          />
        </div>
        {/* Select Template Dropdown */}
        { mydata.usertype==='PRO'?<div className="flex flex-col">
          <label className="font-medium text-start text-sm mb-2 text-[#1c2a3a]">Select Template</label>
          <select
            className="border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-[#1c2a3a]"
            value={selectedTemplate}
            onChange={(e) => {
        
              setSelectedTemplate(e.target.value);
              setSelectedSection("");
            }}
          >
            <option value="">Choose Template</option>
            {templates
  .filter(template => template === 'HnP' || template === 'soap_note')
  .map((template) => (
    <option key={template} value={template}>
      {formatSection(template)}
    </option>
))}

          </select>
        </div>:<></>}

        {/* Select Section Dropdown */}
       { mydata.usertype==='PRO'?<div className="flex flex-col">
          <label className="font-medium text-sm mb-2 text-start text-[#1c2a3a]">Select Section</label>
          <select
            className="border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-[#1c2a3a]"
            value={selectedSection}
            onChange={(e) => setSelectedSection(e.target.value)}
            disabled={!selectedTemplate}
          >
            <option value="">Choose Section</option>
            {sections.map((section) => (
              <option key={section} value={section}>{formatSection(section)}</option>
            ))}
          </select>
        </div>
      :<></>  }
        {extractedText ? (
  <div className="flex flex-col">
    <label className="font-medium text-sm mb-2 text-start text-[#1c2a3a]">
      Extracted Text
    </label>
    <textarea
      className="border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-[#1c2a3a] w-full h-32 resize-none"
      value={extractedText}
      onChange={(e) => setExtractedText(e.target.value)}
    />
  </div>
):<>
     <div className="flex flex-col"
        onClick={()=>{
          if(!selectedSection&&mydata.usertype==='PRO'){
            setSeverity("info")
            setAlertMessage('please select a section')
            setOpen(true)
          }
        }}
        >
          <label className="font-medium text-sm mb-2 text-[#1c2a3a] text-start">Upload File</label>
          <div {...getRootProps()} className="border border-dashed border-gray-400 p-6 rounded-md flex flex-col items-center cursor-pointer hover:bg-gray-100 transition-all">
            <input {...getInputProps()} disabled={!selectedSection&&mydata.usertype==='PRO'}  />
            <p className="text-sm text-gray-500">Drag & drop or click to upload</p>
            <button className="mt-2 px-4 py-1 bg-[#1c2a3a] text-white text-sm rounded-md">Browse</button>
          </div>
          <p className="text-gray-500 text-xs mt-2 text-start">Valid formats: pdf, png, jpg, jpeg</p>
        </div>

        {uploadedSignature && <p className="text-sm text-[#1c2a3a] mt-2 font-semibold">File: {uploadedSignature.name}</p>}

</>}
        {/* Upload File */}
   
 
       

        <div className="w-full flex justify-end gap-2 mt-4">
          <button
            onClick={() => {setExtractedText('')
              setUploadedSignature(null)
              setSelectedTemplate('')
              setTemplateName('')
              setSelectedSection('')
               setUploadedSignature(null)
               setIsuploadmodal(false); }}
            className="px-4 py-2 bg-gray-200 text-gray-800 text-sm font-semibold rounded-md hover:bg-gray-300 transition-all"
          >
            Cancel
          </button>
          <button
            disabled={!isUploadEnabled}
            onClick={handleSave}
            className={`px-4 py-2 text-sm font-semibold rounded-md transition-all ${
              isUploadEnabled ? "bg-[#1C2A3A] text-white hover:bg-[#16222F]" : "bg-gray-300 text-gray-500 cursor-not-allowed"
            }`}
          >
            Upload
          </button>
        </div>
      </div>

      {/* Loading Backdrop */}
      <Backdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: "rgba(0, 0, 0, 0.5)" }} open={loading}>
        <div className="text-white font-mono text-xl font-bold">Extracting Text...</div>
      </Backdrop>
       <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={submit}>
                <CircularProgress color="inherit" />
              </Backdrop>
    </div>
  );
};

export default SectionUpdate;
